var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKnife(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 417,
    viewBox: "0 0 180 417",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M164 0H16C7.16344 0 0 7.16344 0 16V400.01C0 408.847 7.16344 416.01 16 416.01H164C172.837 416.01 180 408.847 180 400.01V16C180 7.16344 172.837 0 164 0Z",
    fill: "#FF9685"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.15 404.64C91.3528 404.64 88.5927 403.999 86.0817 402.766C83.5706 401.534 81.3754 399.742 79.6645 397.529C77.9536 395.316 76.7724 392.741 76.2117 390C75.651 387.26 75.7257 384.427 76.43 381.72L79.78 368.85C80.78 365.18 81.51 348.08 81.51 344.29L85 212.11C84.53 174.82 80.94 192.17 73.18 184.36C71.3711 182.516 70.3034 180.07 70.18 177.49L73.81 71.2001C73.81 70.0401 73.96 68.88 73.99 67.72C75.82 4.84004 100.99 11.29 106.99 14.32C107.354 14.5033 107.633 14.8191 107.771 15.2024C107.909 15.5857 107.894 16.0072 107.73 16.38C100.73 32.83 102.59 202.52 102.59 211.61L106.4 341.61C106.697 351.634 107.588 361.632 109.07 371.55L111.8 381.39C112.563 384.113 112.685 386.975 112.156 389.753C111.627 392.531 110.463 395.149 108.753 397.401C107.043 399.653 104.835 401.479 102.301 402.735C99.7677 403.991 96.9778 404.643 94.15 404.64Z",
    fill: "#CCC2C2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.74 401.66C99.4176 401.333 101.947 400.251 104.033 398.541C106.119 396.83 107.675 394.562 108.52 392",
    stroke: "#EDE8E8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M109.23 384C109.55 385.554 109.55 387.156 109.23 388.71",
    stroke: "#EDE8E8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M99.97 201.2L101.16 312.13",
    stroke: "#EDE8E8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M100.67 14.45C100.67 14.45 90.67 12.12 83.12 28.96",
    stroke: "#EDE8E8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.36 32.08C81.36 32.08 79.75 37.92 79.75 39.53",
    stroke: "#EDE8E8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnife);
export default __webpack_public_path__ + "static/media/knife.55251025900029bb6af9ee8c652acba4.svg";
export { ForwardRef as ReactComponent };